module.exports = __webpack_public_path__ + "bf714e97bf842288027084df942580ce.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VN.svg
// module id = Lb7R
// module chunks = 0